import React, { Component, PropTypes } from 'react';
import Circle from './layout/Circle';
import { Icon } from 'react-fast-ui';
import cx from 'classnames';

const USER_ICON = (
  <Icon className="color-white" name="user" size="2x"/>
);

export default class RecruitPhoto extends Component {
  static propTypes = {
    // the url of the photo
    value: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    placeholder: PropTypes.node,
    diameter: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ])
  };

  static defaultProps = {
    diameter: '4rem',
    placeholder: USER_ICON
  };

  render() {
    const { value, placeholder, diameter, className, onClick } = this.props;

    // circle content
    let content;

    if (value) {
      content = (
        <img alt="recruit_photo" className="full-height full-width" style={{ borderRadius: '100%' }} src={value}/>
      );
    } else {
      content = (
        <div
          className="bg-color-light-gray full-height full-width display-flex align-items-center justify-content-center"
        >
          { placeholder }
        </div>
      );
    }

    return (
      <span className={cx('display-inline-block', className)}>
        <Circle
          className="box-shadow-sm cursor-pointer bg-color-white"
          diameter={diameter}
          onClick={onClick}
        >
          { content }
        </Circle>
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/RecruitPhoto.jsx